import './blog-article.css';
import { Header } from "../../components/widgets/header/header";
import { KnowledgeBase } from "../../components/widgets/knowledge-base-section/knowledge-base";
import { smoothScroll } from "../index/smooth-scroll";

export function initBlogArticlePage() {
  Header.init();
  smoothScroll.init();
  KnowledgeBase.init();
}